import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {Link} from "react-router-dom";
import { ArmyBookView } from '@Selectors/publication/book/view/army-book.view';

interface BookProps {
  book: ArmyBookView
}

const ArmyBookComponent: React.FC<Props> = ({book}) => {
  return (
    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 army_list_row text-center">
      <Link to={`/${document.documentElement.lang}/publication/books/armies/${book.id}`}>
        <h4 className="boxtitre">{(book.name || '').substring(0, 60)}</h4>
        <small>{book.version}</small>
      </Link>
    </div>
  );
};

const mapStateToProps = (_: AppState, owsProps: BookProps) => ({
  book: owsProps.book
})

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyBookComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  BookProps
